import React from 'react';


class MinStockInlineEditField extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isEditing: false,
            origValue: props.value,
            value: props.value
        };
        this.edit = this.edit.bind(this);
        this.cancel = this.cancel.bind(this);
        this.change = this.change.bind(this);
        this.commit = this.commit.bind(this);
    }

    edit() {
        this.setState({isEditing: true})
    }

    cancel() {
        this.setState({isEditing: false, value: this.state.origValue});
    }

    change(event) {
        this.setState({value: event.target.value});
    }

    commit() {
        const promise = this.props.onCommit(this.state.value);
        // promise.finally( () => this.setState({isEditing: false}));
        this.setState({isEditing: false});
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.isEditing) return;

        if(nextProps.value === this.state.value) return;

        this.setState({
            isEditing: false,
            origValue: nextProps.value,
            value: nextProps.value
        });
    }

    render() {
        if (this.state.isEditing) {
            return (
                <div style={{width: this.props.width}}>
                    <div className="input-group">
                        <input type="number" min={1} value={this.state.value} name="minstock" className="form-control" style={{fontSize: 'small', padding: '0.5rem 0.25rem'}} onChange={this.change}/>
                        <div className="input-group-btn">
                            <button className="btn btn-success" style={{padding: '0.5rem 0.25rem'}} onClick={this.commit}><i className="fa fa-check"/>&nbsp;</button>
                            <button className="btn btn-secondary" style={{padding: '0.5rem 0.25rem'}}  onClick={this.cancel}><i className="fa fa-times" />&nbsp;</button>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <p style={{padding: '0', margin: '0'}}>
                <span style={{fontWeight: 'bold', fontSize: 'large'}}>{this.state.value}</span>
                <span style={{fontSize: 'large', marginLeft: '0.25rem'}} className="fa fa-pencil-alt" onClick={this.edit}></span>
            </p>
        );
    }
}

MinStockInlineEditField.defaultProps = {width: '200px'};

export default MinStockInlineEditField;



// WEBPACK FOOTER //
// ./src/admin/areacontrol/overview/MinStockInlineEditField.js